<template>
  <a-modal
    title="确认提交"
    cancel-text="取消"
    ok-text="提交"
    width="70%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-layout v-for="canvas in canvasSet" :key="canvas.id">
      <a-layout-content :style="{padding:'15px', border: '1px solid #ccc'}">
        <Preview
          :img="canvas.option.img.url"
          :scale="canvas.option.img.scale"
          :imgX="canvas.option.img.x"
          :imgY="canvas.option.img.y"
          :imgTrueWidth="canvas.option.img.trueWidth"
          :imgTrueHeight="canvas.option.img.trueHeight"
          :cropX="canvas.option.crop.x"
          :cropY="canvas.option.crop.y"
          :cropW="canvas.option.crop.cropW"
          :cropH="canvas.option.crop.cropH"
          :frameX="canvas.option.frame.x"
          :frameY="canvas.option.frame.y"
          :frameWidth="canvas.option.frame.width"
          :frameHeight="canvas.option.frame.height"
          :bgColor="canvas.properties.bgColor"
          :zoom="0.7"
        />
      </a-layout-content>
      <a-layout-sider width="250" theme="light" :style="{padding: '10px'}">
        <a-form-model
          ref="propertyForm"
          :model="canvas.properties"
          :rules="rules"
          :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }"
        >
          <a-form-model-item label="单号">
            {{orderId}}
          </a-form-model-item>
          <a-form-model-item label="宽度" prop="width">
            {{canvas.properties.width}} (厘米)
          </a-form-model-item>
          <a-form-model-item label="高度" prop="height">
            {{canvas.properties.height}} (厘米)
          </a-form-model-item>
          <a-form-model-item label="面料" prop="mianliao">
            <template v-if="canvas.properties.mianliao.value!='other'">
            {{canvas.properties.mianliao.value}}
            </template>
            <template v-else>
              {{canvas.properties.mianliao.other}}
            </template>
          </a-form-model-item>
          <a-form-model-item label="单双面" prop="face">
            {{canvas.properties.face}}
          </a-form-model-item>
          <a-form-model-item label="备注" prop="note">
            {{canvas.properties.note}}
          </a-form-model-item>
        </a-form-model>
      </a-layout-sider>
    </a-layout>

</a-modal>
</template>

<script>
import Preview from './Preview.vue'
export default {
  components: {
    Preview
  },
  props: ['orderId'],
  data () {
    return {
      visible: false,

      rules: {
        width: {
          required: true, min: 1, max: 300, type: 'number', trigger: 'change', message: '请填写 1 ~ 300 内的数字'
        },
        height: {
          required: true, min: 1, max: 300, type: 'number', trigger: 'change', message: '请填写 1 ~ 300 内的数字'
        },
        curtainHead: {
          required: true, min: 0, type: 'number', trigger: 'change', message: '请填写数字'
        },
        mianliao: {
          required: true,
          message: '缺少面料信息',
          trigger: 'change',
          validator: (rule, mianliao, callback) => {
            if (mianliao.value && mianliao.value !== 'other') {
              return callback()
            } else if (mianliao.value && mianliao.other) {
              return callback()
            }
            return callback(new Error('缺少面料信息'))
          }
        },
        face: {required: true, trigger: 'change', message: '未选择'}
      },
      allValid: false,
      confirmLoading: false,
      canvasSet: [{
        id: '',
        option: {
          img: {},
          crop: {},
          frame: {}
        },
        properties: {mianliao: {}}
      }]
    }
  },
  methods: {
    show (data) {
      this.visible = true
      this.canvasSet = data
    },
    hide (cmd) {
      this.visible = false
    },
    handleOk () {
      if (this.allValid) {
        this.$emit('submit')
        this.visible = false
      } else {
        this.$error({
          title: '错误提示',
          content: '请补充完整必要的信息',
          centered: true
        })
      }
    },
    handleCancel () {
      this.visible = false
    }
  },
  updated () {
    let forms = []
    if (Array.isArray(this.$refs.propertyForm)) {
      forms = this.$refs.propertyForm
    } else if (this.$refs.propertyForm) {
      forms.push(this.$refs.propertyForm)
    } else {
      return
    }

    this.allValid = true
    this.$nextTick(_ => {
      forms.forEach(f => {
        f.validate(valid => {
          if (!valid) {
            this.allValid = false
          }
        })
      })
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/design/SubmitConfirm.vue